/**
 * @fileoverview Outbound Link Tracker
 * Utility for tracking clicks on external links
 */

import AnalyticsService from '../services/analytics/AnalyticsService';

/**
 * Check if a URL is external (outbound)
 * @param {string} url - URL to check
 * @returns {boolean} True if URL is external
 */
export const isOutboundLink = (url) => {
  try {
    const link = new URL(url, window.location.href);
    return link.hostname !== window.location.hostname;
  } catch (error) {
    return false;
  }
};

/**
 * Track outbound link click
 * @param {string} url - Outbound link URL
 * @param {Event} event - Click event (optional)
 */
export const trackOutboundLinkClick = (url, event = null) => {
  if (isOutboundLink(url)) {
    AnalyticsService.trackOutboundLink(url);

    // If event is provided and link opens in same window, delay navigation
    const anchor = event ? event.target.closest('a') : null;
    if (event && anchor && (!anchor.target || anchor.target === '_self')) {
      event.preventDefault();

      // Navigate after a short delay to ensure tracking completes
      setTimeout(() => {
        window.location.href = url;
      }, 150);
    }
  }
};

/**
 * Initialize automatic outbound link tracking
 * Adds click listeners to all external links on the page
 */
export const initializeOutboundLinkTracking = () => {
  // Track clicks on all links
  document.addEventListener('click', (event) => {
    // Find the closest anchor element
    const link = event.target.closest('a');
    
    if (link && link.href) {
      trackOutboundLinkClick(link.href, event);
    }
  }, true);
};
